export default "__VITE_ASSET__b1c3cb66__"